import type { Achievement } from "../achievement.types";

export const secondThoughtsAchievement: Achievement = {
  id: "secondThoughts",
  name: "Second Thoughts",
  icon: "undo-variant",
  description: "Backtracked more than three times in one game.",
  isProgressive: true,
  // Rule unchanged from v1's Sorry, Wrong Room (spec 2026-10-20 §3.2).
  check: (gameReport, gameStatus) => {
    if (
      !["won", "given_up"].includes(gameStatus) ||
      !gameReport ||
      !gameReport.backtrackEvents
    ) {
      return false;
    }
    return gameReport.backtrackEvents.length > 3;
  },
};
